module.exports = __webpack_public_path__ + "static/media/g-2-b.69757ad6.jpg";